import { ArrowRight, ArrowUpRight } from "lucide-react";
import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { productLinks } from "../../data/products";
import { useReducedMotion } from "../../hooks/useReducedMotion";
import { ease } from "../ui/Reveal";
import { HeroIllustration } from "./HeroIllustration";

export function Hero() {
  const reduced = useReducedMotion();
  const heroRef = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"],
  });
  const photoY = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const artY = useTransform(scrollYProgress, [0, 1], [0, -40]);

  const enter = (delay: number) => ({
    initial: reduced ? false : { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, delay, ease },
  });

  return (
    <section id="home" ref={heroRef} className="landing-hero">
      <motion.img
        className="hero-photograph"
        src="/assets/landing/interior.webp"
        alt=""
        width="2200"
        height="1467"
        fetchPriority="high"
        style={reduced ? undefined : { y: photoY }}
      />
      <div className="hero-shade" />
      <div className="hero-copy">
        <motion.h1 {...enter(0)}>
          Services and{" "}
          <br />
          <span>food deals.</span>
        </motion.h1>
        <motion.p {...enter(0.1)}>
          Book professionals, manage your business, and buy surplus food.
        </motion.p>
        <motion.div className="hero-actions" {...enter(0.18)}>
          <a className="button button-white" href={productLinks.services}>
            Browse services <ArrowUpRight size={16} />
          </a>
          <Link to="/#products" className="button button-outline">
            View all products <ArrowRight size={16} />
          </Link>
        </motion.div>
      </div>
      <motion.div
        className="hero-art"
        style={reduced ? undefined : { y: artY }}
        initial={reduced ? false : { opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2, ease }}
      >
        <HeroIllustration />
      </motion.div>
    </section>
  );
}
